/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputSignalIntegrationStatus
 */
export interface OutputSignalIntegrationStatus {
    /**
     * 
     * @type {string}
     * @memberof OutputSignalIntegrationStatus
     */
    status?: string;
}

/**
 * Check if a given object implements the OutputSignalIntegrationStatus interface.
 */
export function instanceOfOutputSignalIntegrationStatus(value: object): boolean {
    return true;
}

export function OutputSignalIntegrationStatusFromJSON(json: any): OutputSignalIntegrationStatus {
    return OutputSignalIntegrationStatusFromJSONTyped(json, false);
}

export function OutputSignalIntegrationStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputSignalIntegrationStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function OutputSignalIntegrationStatusToJSON(value?: OutputSignalIntegrationStatus | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': value['status'],
    };
}

